import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import LanguageDetector from 'i18next-browser-languagedetector';


//https://medium.com/@mesith621/mastering-multilingual-apps-a-guide-to-building-scalable-and-maintainable-solutions-with-4fa3bad151b9


i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: {
          you_need: "You need start cctv with google login",
          device_id: "Device ID",
          start_time: "StartTime",
          update_time: "UpdateTime",
          time_zone: "TimeZone",
          battery: "Battery",
          state: "State",
          cctv_view: "CCTV View",
          home_link: "Home Link",

          file_list: "Record Files",
          cctv_delete: "CCTV Delete",
          download: "Download",
          features: "Features",
          howtouse: " How to use",
          privacy_policy: "Privacy policy",
          contact: "Contact",
          login:"Login with Google",
          download_link: "Download Link",
          realtime : "Realtime monitoring on PC,Android,IPhone",
          recording : "Recording any time any access",
          getting : "Getting event by discord",
          suppoted : "Suppoted multi connection",
          youtube : "Youtube tutorial link",
          start_cctv_mode : "Start CCTV Mode",
          click_cctv_mode:"-Click button \"CCTV MODE\"",
          select_recording : "-Select recording type",
          click_cctv_start:"-Click button \"CCTV START\"",
          share:"Share and Monitoring CCTV",
          click_share:"-Click button \"CCTV SHARE\"",
          copy_url : "-Copy URL to clipboard or capture QR code by your other camera",
          connecting : "-Connecting with URL on PC or other Phone",
          email : "Your Email",
          message : "Message",
          send: "Send",
          success:"Success message sending",
          file : "Fail message sending",
          
          submenu_event_alarm : "Set event alarm"
        },
      },
      ko: {
        translation: {
          Live : "라이브",
          you_need: "안드로이드 CCTV 사용시 구글로그인을 하셔야 합니다.",
          device_id: "디바이스 ID",
          start_time: "시작시간",
          update_time: "업데이트시간",
          time_zone: "타임존",
          battery: "배터리",
          state: "상태",
          cctv_view: "CCTV 보기",
          home_link: "홈 링크",
          file_list: "저장파일보기",
          cctv_delete: "CCTV 지우기",
          download: "다운로드",
          features: "기능",
          howtouse: " 사용법",
          privacy_policy: "개인정보정책",
          contact: "문의",
          login:"구글로그인",
          download_link: "다운로드 링크",
          realtime : "PC,안드로이드,아이폰으로 어디서든 실시간 원격모니터링이 가능합니다.",
          recording : "다양한 녹화 방식과 어디서든 접근이 가능합니다.",
          getting : "디스코드로 실시간 이벤트 정보를 받을 수 있습니다.",
          suppoted : "여러명이 동시 모니터링이 가능합니다.",
          youtube : "유투브 튜토리얼 링크",
          start_cctv_mode : "CCTV Mode 실행하기",
          click_cctv_mode:"-\"CCTV MODE\" 버튼 클릭",
          select_recording : "-레코딩 타입 선택",
          click_cctv_start:"-\"CCTV START\"버튼 클릭",
          share:"CCTV 모니터링 및 공유",
          click_share:"-\"CCTV SHARE\" 버튼 클릭",
          copy_url : "- URL 클립보드 복사 또는 QR 코드를 다른 핸드폰으로 복사하여 다른 사용자게 전달",
          connecting : "-전달받은 URL 로 PC, 안드로이드, 아이폰 으로 접속",
          
          email : "보내는 사람 이메일",
          message : "내용",
          send: "보내기",

          success:"성공적으로 이메일이 전송되었습니다.",
          file : "이메일이 전송이 실패되었습니다.",

          submenu_event_alarm : " - 이벤트 알람 설정"
        },
      },

      // ["nl-BE"]: {
      //   translation: {
      //     fname: "Voornaam",
      //     lname: "Achternaam",
      //     mobile: "mobiel nummer",
      //     address: "Adres",
      //     message: "Bericht",
      //   },
      // },
    },
    
    // keys or params to lookup language from
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',
    lookupFromPathIndex: 0,
    lookupFromSubdomainIndex: 0,
  
    // cache user language on
    caches: ['localStorage', 'cookie'],
    excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
  
    // optional expire and domain for set cookie
    cookieMinutes: 10,
    cookieDomain: 'myDomain',
  
    // optional htmlTag with lang attribute, the default is:
    htmlTag: document.documentElement,
  
    // optional set cookie options, reference:[MDN Set-Cookie docs](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie)
    cookieOptions: { path: '/' },
    
    fallbackLng: "en",

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;